
import { 
    Bars, 
  } from 'react-loader-spinner'
  
  export const data = [
    {
        Component: Bars,
        props: {
          color: 'blue',
          height: 200,
          width: 220,
        },
        name: 'Ball Triangle',
      },
    
  ]